import { Link } from "@/components/common/Link";
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const infraPmLinks = [{
    label: "Resource Center",
    to: "/ResourceCenterPage"
  }, {
    label: "Grant Coordination",
    to: "#"
  }, {
    label: "Implementation",
    to: "#"
  }];
  const supportLinks = [{
    label: "Contact Us",
    to: "/ConnectPage"
  }, {
    label: "Project Inquiry",
    to: "/ConnectPage"
  }, {
    label: "Agency Support",
    to: "/ConnectPage"
  }];
  const linkClasses = "group/link relative inline-block text-[0.9375rem] font-normal text-foreground transition-colors duration-180 ease-out hover:text-accent";
  const smallLinkClasses = "group/link relative inline-block self-start text-[0.8125rem] font-normal leading-[1.45] text-muted-foreground transition-colors duration-180 ease-out hover:text-foreground";
  const underlineSpan = <span aria-hidden="true" className="pointer-events-none absolute left-0 right-0 top-full mt-1 block h-px bg-foreground transition-all duration-180 ease-out group-hover/link:bg-accent group-hover/link:right-[-8px]" />;
  const smallUnderlineSpan = <span aria-hidden="true" className="pointer-events-none absolute left-0 right-0 top-full mt-1 block h-px bg-border transition-all duration-180 ease-out group-hover/link:bg-accent group-hover/link:right-[-8px]" />;
  return <section data-section-id="10435" id="site-footer" className="bg-background font-default text-foreground">
      <div className="mx-auto w-full max-w-[1440px] px-[clamp(20px,4vw,56px)]">
        <div className="h-px w-full bg-foreground" aria-hidden="true" />

        

        <div className="h-px w-full bg-foreground" aria-hidden="true" />

        <div className="flex flex-col gap-6 pt-10 pb-10 md:flex-row md:items-center md:justify-between md:gap-0">
          <div className="flex flex-col gap-3 md:flex-row md:gap-8">
            <Link to="#" className={smallLinkClasses}>InfraPM 2026 © All rights reserved</Link>

            

            
          </div>

          <p className="font-mono text-[0.8125rem] font-normal leading-[1.4] text-muted-foreground md:text-right">Built for Public Good.</p>
        </div>
      </div>
    </section>;
}